module.exports = __webpack_public_path__ + "banquet/components/images/quantity_increase.7cf5e5fe30eee38f4f5baf31389ee4f6.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/quantity_increase.png
// module id = 1043
// module chunks = 1